<div id="config-add-exception-container">
  <p class="subheading-01-semi-bold">Agente</p>
  <div id="dropdown">
    <qr-input-autocomplete
      [config]="this.inputAutocomplete"
      (selectedChange)="dropdownYearsChange($event)"
    ></qr-input-autocomplete>
  </div>
</div>
